/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_TerminalInputs */

const en_tut_terminal = /** @type {(inputs: Tut_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal`)
};

const id_tut_terminal = /** @type {(inputs: Tut_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal`)
};

/**
* | output |
* | --- |
* | "Terminal" |
*
* @param {Tut_TerminalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_terminal = /** @type {((inputs?: Tut_TerminalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_TerminalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_terminal(inputs)
	return en_tut_terminal(inputs)
});